import styled from 'styled-components';

import { Typography } from '../../../Typography';

export const PaginationContainer = styled.div`
  padding: ${({ theme }) => theme.spaces.xl}rem 0 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
`;

export const PaginationButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  position: relative;
  &[data-tooltip]:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    top: calc(100% + 0.8rem);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.88);
    color: white;
    padding: 0.6rem 1.1rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 0.3rem 0.8rem rgba(0, 0, 0, 0.25);
    font-weight: 500;
  }
  &[data-tooltip]:hover::before {
    content: '';
    position: absolute;
    top: calc(100% + 0.1rem);
    left: 50%;
    transform: translateX(-50%);
    border: 0.5rem solid transparent;
    border-bottom-color: rgba(0, 0, 0, 0.88);
    z-index: 1000;
    pointer-events: none;
  }
`;

export const PaginationButtonNext = styled(PaginationButton)`
  padding: 0 ${({ theme }) => theme.spaces.xxs}rem;
  margin: 0 ${({ theme }) => theme.spaces.m}rem;
`;

export const PaginationButtonPrev = styled(PaginationButton)`
  padding: 0 ${({ theme }) => theme.spaces.xxs}rem;
  margin: 0 ${({ theme }) => theme.spaces.m}rem;
`;


export const Icon = styled.img`
  vertical-align: middle;
  width: 0.7rem;
  height: 1.4rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1rem;
    height: 1.8rem;
  }
`;

export const IconInit = styled(Icon)``;

export const IconEnd = styled(Icon)``;

export const CountTotal = styled(Typography)`
  align-self: center;
`;
